module.exports = __webpack_public_path__ + "static/slide-1-79ca01c9bfd1b95eb44e2de1fc61ba58.jpg";